module.exports = __webpack_public_path__ + "static/media/ap.f8ff57c5.jpg";